import { useEffect, useState } from "react"; // Reactフック
import GuestTestTemplate from "../templates/GuestTestTemplate"; // 問題集テンプレートと型定義
import {  TestType } from "../types/guestTestTemplate";
import { useSearchParams } from "react-router-dom"; // URLのクエリパラメータ取得用フック
import { useRecoilValue } from "recoil"; // グローバル状態管理用
import userState from "../../recoil/atoms/userState"; // ユーザー状態を管理するRecoilアトム
import { dataForNo2 } from "../types/guestMaterial"; // 問題集データ
import useFetchData from "../hooks/useFetchDate";

const GuestTestPage = () => {
    const [searchParams] = useSearchParams(); // URLのクエリパラメータを取得
    const userData = useRecoilValue(userState); // グローバルなユーザーデータを取得
    const [questionData, setQuestionData] = useState<TestType[]>([]) // 質問データ

    // クエリパラメータ "no" を数値に変換して取得
    const questionBookNo = Number(searchParams.get("no"));

    // 質問データを取得するカスタムフックを使用
    const { data: questions = [], loading: questionsLoading, error: questionsError } = useFetchData<any[]>(
        process.env.REACT_APP_BE_HOST + 'workbooks/questions', // APIのエンドポイント
        { userId: userData.userId, questionBook: 7, noImage: true } // リクエストパラメータ
    );

    // 質問データが取得されたときに実行する副作用
    useEffect(() => {
        if (questions) {
            const tmpData: TestType[] = [];
            questions?.forEach((q => {
                // 回答を整列
                const tmpChoices = q.choices?.sort((a: any,b: any) => {
                    if (a.choiceNum > b.choiceNum) {
                        return 1;
                    } else {
                        return -1;
                    }
                })
                tmpData.push({
                    testId: q.questionId,
                    question: q.questionText.replaceAll('\\r\\n','\n').replaceAll('\\n','\n'),
                    choices: tmpChoices,
                    answer: [],
                    explanation: '',
                });
            }));
            // 質問を整列
            tmpData.sort((a,b) => {
                if (a.testId > b.testId) {
                    return 1;
                } else {
                    return -1;
                }
            })
            setQuestionData(tmpData);
        }
    }, [questions]);

    // 回答データを取得するカスタムフックを使用
    const { data: answers = [], loading: answersLoading, error: answersError } = useFetchData<any[]>(
        process.env.REACT_APP_BE_HOST + 'tmpData/InterruptedDataPrevious', // APIのエンドポイント
        { userId: userData.userId, questionBook: 7 } // リクエストパラメータ
    );

    // 回答データが取得されたときに実行する副作用
    useEffect(() => {
        if (answers) {
            console.log(answers)
        }
    }, [answers]);

    // データがロード中の場合の表示
    if (questionsLoading || answersLoading) return <div>Loading...</div>;

    // データ取得エラーが発生した場合の表示
    if (questionsError || answersError) return <div>Error occurred</div>;

    return (
        <>
            <GuestTestTemplate 
                practiceList={[[]]} // 問題リストを二重配列として渡す
                questionBook={questionBookNo} // 現在の問題集番号
                userId={userData.userId} // ユーザーID
                title={dataForNo2[questionBookNo]?.title || "新入社員向け"} // タイトルを取得、存在しない場合はデフォルト
                data={questions ? questions.map((q: TestType) => ({ // 質問データをマッピング
                    ...q,
                    title: q.question // 質問のタイトルを設定
                })) : []} // 質問がない場合は空の配列
                no={searchParams.get("no") || ""} // クエリパラメータ "no" を取得
                questionList={questionData}
            />
        </>
    );
};

export default GuestTestPage;